<template>
	<van-overlay :show="loading" :z-index="9999">
		<div class="loading">
			<div class="loading_center">
				<!-- <van-loading type="spinner"></van-loading> -->
				<div class="lottie_svg">
					<div class="item-img" ref="lottie"></div>
				</div>
				<div class="size">{{ text }}</div>
			</div>
		</div>
	</van-overlay>
</template>

<script>
import { Overlay, Loading } from 'vant'
import lottie from 'lottie-web'

export default {
	components: {
		[Overlay.name]: Overlay,
		[Loading.name]: Loading
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		time: {
			type: Number,
			default: 3000
		},
		text: {
			type: String,
			default: "加载中"
		}
	},
	watch: {
		show: {
			handler(val) {
				if (val) {
					this.loading = val
					this.$nextTick(() => {
						this.initLottie()
					})
				} else {
					this.loading = false
					this.destroyLottie()
				}
			},
			immediate: true
		}
	},
	data() {
		return {
			loading: false,
			anisrc: require("@/assets/image/anijson/refreshImg.json"),
			lottieAnimation: null
		}
	},
	mounted() {
		this.init()
	},
	beforeDestroy() {
		this.destroyLottie()
	},
	methods: {
		init() {
			setTimeout(() => {
				this.loading = false
			}, this.time)
		},
		initLottie() {
			if (this.$refs.lottie && !this.lottieAnimation) {
				try {
					this.lottieAnimation = lottie.loadAnimation({
						container: this.$refs.lottie,
						renderer: 'svg',
						loop: true,
						autoplay: true,
						animationData: this.anisrc
					})
				} catch (error) {
					console.error('Lottie animation failed to load:', error)
				}
			}
		},
		destroyLottie() {
			if (this.lottieAnimation) {
				this.lottieAnimation.destroy()
				this.lottieAnimation = null
			}
		}
	}
}
</script>

<style scoped lang="scss">
.loading {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	line-height: normal;
	flex-direction: column;
	background: rgba(0, 0, 0, 0.3);

	.loading_center {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 2.5rem; // 100rpx / 40 = 2.5rem
		position: relative;

		.lottie_svg {
			position: absolute;
			bottom: 0.2rem; // 8rpx / 40 = 0.2rem
			left: 50%;
			transform: translateX(-50%);
			width: 4.5rem; // 180rpx / 40 = 4.5rem
			height: 4.5rem; // 180rpx / 40 = 4.5rem

			.item-img {
				width: 4.5rem; // 180rpx / 40 = 4.5rem
				height: 4.5rem; // 180rpx / 40 = 4.5rem
			}
		}

		.size {
			padding-top: 1.45rem; // 58rpx / 40 = 1.45rem
			font-size: 0.5rem; // 20rpx / 40 = 0.5rem
			color: #fff;
		}
	}
}
</style>